import {
    Button,
    Card,
    Column,
    FlexBox,
    GridContainer,
    Icon,
    Link,
    Row,
    TabContent,
    TabHeader,
    Tabs,
    TabsContents,
    TabsHeaders,
    Typography,
} from '@vp/swan';
import { useUserContext } from '@vp/ubik-context';
import { IndustryBusinessNameIdeasData } from '../../pages/BusinessNameGeneratorPage/components/content/explore-business-ideas-data';
import { removePathQueryParams } from '../../utils/removePathQueryParams';

interface TabbedButtonLinkGardenProps {
    tabbedButtonLinkGardenData: IndustryBusinessNameIdeasData;
    title: string;
    tabHeaderAriaLabel: string;
    targetBasePath: string;
    onBusinessNameIdeasClickHandler: (
        currentPagePath: string,
        destinationPagePath: string,
        businessNameIdea: string,
    ) => void;
}

const TabbedButtonLinkGarden = ({
    title,
    tabHeaderAriaLabel,
    targetBasePath,
    tabbedButtonLinkGardenData,
    onBusinessNameIdeasClickHandler,
}: TabbedButtonLinkGardenProps) => {
    const firstCategory = Object.keys(tabbedButtonLinkGardenData)[0];
    const pathName = useUserContext().forwardedPath || '';
    const currentPagePath = removePathQueryParams(pathName);

    return (
        <GridContainer>
            <Row marginBottom={'between-actions'}>
                <Column span={12} paddingX={0}>
                    <Typography fontSkin="title-section">{title}</Typography>
                </Column>
            </Row>
            <Row>
                <Column span={12} paddingX={0}>
                    <Tabs defaultSelectedTabId={firstCategory}>
                        <TabsHeaders aria-label={tabHeaderAriaLabel as string} paddingLeft={1}>
                            {Object.keys(tabbedButtonLinkGardenData).map((industry) => (
                                <TabHeader key={industry} tabId={industry}>
                                    {industry}
                                </TabHeader>
                            ))}
                        </TabsHeaders>
                        <TabsContents>
                            {Object.entries(tabbedButtonLinkGardenData).map(([industry, ideas]) => (
                                <TabContent key={industry} tabId={industry}>
                                    <GridContainer>
                                        <Row as="ul">
                                            {ideas.map((idea, idx) => (
                                                <Column
                                                    key={idx}
                                                    span={3}
                                                    spanLg={4}
                                                    spanMd={6}
                                                    spanSm={6}
                                                    marginBottom={{ xs: '4', sm: '6' }}
                                                    as="li"
                                                >
                                                    <Button
                                                        skin="unstyled"
                                                        width="full-width"
                                                        render={(props) => (
                                                            <Link
                                                                to={`${targetBasePath}/${idea.path}`}
                                                                className={props.className}
                                                                onClick={(e) => {
                                                                    const destinationPagePath =
                                                                        (
                                                                            e.currentTarget as HTMLAnchorElement
                                                                        ).getAttribute('href') ||
                                                                        '';
                                                                    onBusinessNameIdeasClickHandler(
                                                                        currentPagePath,
                                                                        destinationPagePath,
                                                                        idea.title,
                                                                    );
                                                                }}
                                                            >
                                                                {props.children}
                                                            </Link>
                                                        )}
                                                    >
                                                        <Card bordered skin="link">
                                                            <FlexBox
                                                                justifyContent="space-between"
                                                                alignItems="center"
                                                                flexDirection="row"
                                                                gap="6"
                                                            >
                                                                <Typography fontSkin="title-item">
                                                                    {idea.title}
                                                                </Typography>
                                                                <Icon
                                                                    size="24p"
                                                                    iconType="arrowRight"
                                                                />
                                                            </FlexBox>
                                                        </Card>
                                                    </Button>
                                                </Column>
                                            ))}
                                        </Row>
                                    </GridContainer>
                                </TabContent>
                            ))}
                        </TabsContents>
                    </Tabs>
                </Column>
            </Row>
        </GridContainer>
    );
};

export default TabbedButtonLinkGarden;
